export type QuarterOption = {
    id: string;
    label: string;
    shortLabel: string;
    start: string;
    end: string;
};

export const QUARTER_OPTIONS: QuarterOption[] = [
    { id: "2025-Q3", label: "Q3 2025", shortLabel: "Q3'25", start: "2025-07-01", end: "2025-10-01" },
    { id: "2025-Q4", label: "Q4 2025", shortLabel: "Q4'25", start: "2025-10-01", end: "2026-01-01" },
    { id: "2026-Q1", label: "Q1 2026", shortLabel: "Q1'26", start: "2026-01-01", end: "2026-04-01" },
];

export const DEFAULT_QUARTER_ID = "2026-Q1";

export const findQuarter = (id: string | null): QuarterOption => {
    const match = QUARTER_OPTIONS.find((quarter) => quarter.id === id);
    if (match !== undefined) return match;
    const fallback = QUARTER_OPTIONS.find((quarter) => quarter.id === DEFAULT_QUARTER_ID);
    return fallback !== undefined ? fallback : QUARTER_OPTIONS[QUARTER_OPTIONS.length - 1];
};
